import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import resetPassword from '../../API/resetPasswordAPI';
import './PasswordReset.css';

const PasswordReset = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleFormSubmission = async (event) => {
    event.preventDefault();

    // Check if passwords match before making the API call
    if (newPassword !== confirmPassword) {
      setMessage('Passwords do not match.');
      setMessageType('error');
      return;
    }

    // Extract token from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (!token) {
      setMessage('Invalid reset token.');
      setMessageType('error');
      return;
    }

    // Call the API to reset the password
    const result = await resetPassword(token, newPassword);
    if (result.success) {
      setMessage('Password has been reset successfully.');
      setMessageType('success');
      setTimeout(() => {
        navigate('/login');
      }, 3000); // Redirect after 3 seconds
    } else {
      setMessage(result.message);
      setMessageType('error');
    }
  };

  return (
    <div className="password-reset-container">
      <h2 className="password-reset-title">Reset Password</h2>
      <form onSubmit={handleFormSubmission} className="password-reset-form">
        <div className="password-reset-form-group">
          <input
            type="password"
            id="newPassword"
            name="newPassword"
            className="password-reset-input"
            placeholder=" "
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <label htmlFor="newPassword" className="password-reset-label">
            New Password
          </label>
        </div>
        <div className="password-reset-form-group">
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            className="password-reset-input"
            placeholder=" "
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <label htmlFor="confirmPassword" className="password-reset-label">
            Confirm New Password
          </label>
        </div>
        {message && (
          <p className={`password-reset-message ${messageType}`}>
            {message}
          </p>
        )}
        <button type="submit" className="password-reset-submit-btn">
          Reset Password
        </button>
      </form>
      <div className="password-reset-login-link">
        <button onClick={() => navigate('/login')} className="password-reset-login-anchor">
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default PasswordReset;
